import { call, put, takeEvery } from "redux-saga/effects"
import {
  GET_FILE_BY_AREA,
  UPLOAD_FILE,
  DOWNLOAD_FILE,
  SEND_EMAIL_SUPPLIER,
  DELETE_FILE_UPLOAD,
} from "./actionTypes"
import {
  getFilesByAreaSuccess,
  getFilesByAreaFail,
  fileToUploadFail,
  fileToUploadSuccess,
  downloadFileSuccess,
  downloadFileFail,
  sendEmailFail,
  sendEmailSuccess,
  deleteFilesFail,
  deleteFilesSuccess,
} from "./actions"
import service from "../../api/fileUpload.service"

function* fetchFilesByArea({ payload: filter }) {
  try {
    const response = yield call(service.getFilesByArea, filter.filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(getFilesByAreaFail(error))
    } else {
      yield put(getFilesByAreaSuccess(response))
    }
  } catch (error) {
    yield put(getFilesByAreaFail(error))
  }
}

function* fetchUploadData({ payload: file }) {
  try {
    const response = yield call(service.uploadData, file.file)
    if (response?.data?.status != 200) {
      yield put(fileToUploadFail(response))
    } else {
      yield put(fileToUploadSuccess(response))
    }
  } catch (response) {
    yield put(fileToUploadFail(response))
  }
}
function* fetchDownloadFiles({ payload: path }) {
  try {
    const response = yield call(service.downloadFile, path)
    const error = response?.response?.data?.data?.error
    if (error) yield put(downloadFileFail(error))
    else yield put(downloadFileSuccess(response))
  } catch (error) {
    yield put(downloadFileFail(error))
  }
}
function* sendEmailsSaga({ payload: body }) {
  try {
    const response = yield call(service.sendEmail, body)
    const error = response?.response?.data?.data?.error
    if (error) yield put(sendEmailFail(error))
    else yield put(sendEmailSuccess(response))
  } catch (error) {
    yield put(sendEmailFail(error))
  }
}

function* fetchDeleteFiles({ payload: body }) {
  try {
    const response = yield call(service.deleteFileService, body)
    const error = response?.response?.data?.data?.error
    if (error) yield put(deleteFilesFail(error))
    else yield put(deleteFilesSuccess(response))
  } catch (error) {
    yield put(deleteFilesFail(error))
  }
}
function* fileUploadSaga() {
  yield takeEvery(GET_FILE_BY_AREA, fetchFilesByArea)
  yield takeEvery(UPLOAD_FILE, fetchUploadData)
  yield takeEvery(DOWNLOAD_FILE, fetchDownloadFiles)
  yield takeEvery(SEND_EMAIL_SUPPLIER, sendEmailsSaga)
  yield takeEvery(DELETE_FILE_UPLOAD, fetchDeleteFiles)
}

export default fileUploadSaga
